import React from 'react'

const Entertainment = () => {
  const artists = [
    { name: "Mehandi Artist", desc: "Traditional & contemporary designs", icon: "fa-hand-sparkles", color: "#f5576c" },
    { name: "Face Painting", desc: "Colorful designs for kids & adults", icon: "fa-paint-brush", color: "#667eea" },
    { name: "Caricature & Portrait Artist", desc: "Live sketching entertainment", icon: "fa-user-tie", color: "#1abc9c" },
    { name: "Tattoo Artist", desc: "Temporary & spray tattoos", icon: "fa-stamp", color: "#fa709a" },
    { name: "Hair Styling", desc: "Trendy styles & updos", icon: "fa-cut", color: "#4facfe" },
    { name: "Magician", desc: "Mind-blowing illusions & tricks", icon: "fa-magic", color: "#764ba2" },
    { name: "Sangeet Artists", desc: "Traditional & modern performances", icon: "fa-music", color: "#16a085" }
  ]

  const activities = [
    { name: "Pot Painting", desc: "Interactive pottery decoration", icon: "fa-brush", color: "#667eea" },
    { name: "Beats Making", desc: "Create your own music beats", icon: "fa-drum", color: "#1abc9c" },
    { name: "Balloon Sculpting", desc: "Balloon animals & creations", icon: "fa-shapes", color: "#f5576c" },
    { name: "Nail Art", desc: "Beautiful nail designs & decorations", icon: "fa-fingerprint", color: "#fa709a" },
    { name: "Spray Tattoo", desc: "Airbrush temporary tattoos", icon: "fa-spray-can", color: "#764ba2" }
  ]

  const entertainment = [
    { name: "Photo Booth Experiences", desc: "AI, 360°, Greenscreen & more", icon: "fa-camera", color: "#1abc9c" },
    { name: "Video Booth", desc: "Record personalized messages", icon: "fa-video", color: "#f5576c" },
    { name: "Virtual Reality Games", desc: "Immersive VR gaming experience", icon: "fa-vr-cardboard", color: "#667eea" },
    { name: "Carnival Games", desc: "50+ exciting game options", icon: "fa-dice", color: "#fa709a" },
    { name: "Mascots", desc: "Character performers for events", icon: "fa-user-ninja", color: "#764ba2" }
  ]

  return (
    <section id="entertainment" className="py-16 px-4 md:px-6">
      <div className="container mx-auto">
        <div className="section-bg">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold section-title-enhanced mb-6">
              🎪 Fun Activities & Entertainment
            </h2>
            <p className="text-xl text-white max-w-3xl mx-auto leading-relaxed">
              Engage your guests with exciting activities and talented artists that add the perfect touch of entertainment to your event.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {/* Artists Column */}
            <div className="card p-6">
              <h3 className="text-2xl font-bold mb-6 text-gray-800 text-center flex items-center justify-center">
                <i className="fas fa-users text-[#1abc9c] mr-3"></i>
                Professional Artists
              </h3>
              <ul className="space-y-4 text-gray-700">
                {artists.map((artist, idx) => (
                  <li key={idx} className="flex items-start p-3 bg-gray-50 rounded-lg">
                    <i className={`fas ${artist.icon} mt-1 mr-3 text-xl`} style={{ color: artist.color }}></i>
                    <div>
                      <strong>{artist.name}</strong>
                      <p className="text-sm text-gray-600">{artist.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            {/* Creative Activities Column */}
            <div className="card p-6">
              <h3 className="text-2xl font-bold mb-6 text-gray-800 text-center flex items-center justify-center">
                <i className="fas fa-palette text-[#f5576c] mr-3"></i>
                Creative Activities
              </h3>
              <ul className="space-y-4 text-gray-700">
                {activities.map((activity, idx) => (
                  <li key={idx} className="flex items-start p-3 bg-gray-50 rounded-lg">
                    <i className={`fas ${activity.icon} mt-1 mr-3 text-xl`} style={{ color: activity.color }}></i>
                    <div>
                      <strong>{activity.name}</strong>
                      <p className="text-sm text-gray-600">{activity.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            {/* Interactive Entertainment Column */}
            <div className="card p-6">
              <h3 className="text-2xl font-bold mb-6 text-gray-800 text-center flex items-center justify-center">
                <i className="fas fa-gamepad text-[#667eea] mr-3"></i>
                Interactive Fun
              </h3>
              <ul className="space-y-4 text-gray-700">
                {entertainment.map((item, idx) => (
                  <li key={idx} className="flex items-start p-3 bg-gray-50 rounded-lg">
                    <i className={`fas ${item.icon} mt-1 mr-3 text-xl`} style={{ color: item.color }}></i>
                    <div>
                      <strong>{item.name}</strong>
                      <p className="text-sm text-gray-600">{item.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Entertainment
